import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setBreakin } from "../Redux/Features/breakinSlice";
import { setIsClaim } from "../Redux/Features/isClaimSlice";
import { setIsPAYD, setOdometerReading } from "../Redux/Features/isPAYDSlice";
import { setIsSunroof } from "../Redux/Features/isSunroofSlice";
import { useNavigate, useLocation } from "react-router-dom";
// import Logo from "../Assets/Images/logo_hdfc.png";
import Loader from "../Components/Loader";
import Modal from "../Components/Modal";
import {
  setCars,
  carCount,
  setCheckCount,
  setSessionId,
  resetCarState,
  resetCarStateInitial,
} from "../Redux/Features/carSlice";
import {
  fetchCarData,
  deleteCarData,
  truncateData,
} from "../services/indexDBService";
import { conditionalSetCars } from "../Redux/Features/carSlice";

import CustomModal from "../Components/CustomModal";
import SunroofToggle from "../Components/SunroofToggle";
import InitialCarData from "../Assets/Data/Car";
import InitialSplitCarData from "../Assets/Data/SplitCar";
import InitialSunroofCarData from "../Assets/Data/sunroofCar";
import ImagePreloader from "../Components/ImagePreloadHead";
// import { setLatitude, setLongitude } from "../Redux/Features/locationSlice";
import { getDynamicToken } from '../utils/authUtils';

import { useTelemetry } from "../telemetry/TelemetryProvider";

const Home = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const breakin = useSelector((state) => state.breakin);
  const querySearch = useLocation().search;

  const breakinID = new URLSearchParams(querySearch).get("breakinID");
  const claimNumber = new URLSearchParams(querySearch).get("claimNumber");
  const userID = new URLSearchParams(querySearch).get("userID");

  let odo_value = new URLSearchParams(querySearch).get("odo_value");
  let source = new URLSearchParams(querySearch).get("Source");

  let claimExists = false;

  const { track, tSessionId } = useTelemetry();

  if (claimNumber) {
    document.title = "Claim Inspection";
    const metaDescriptionTag = document.querySelector(
      'meta[name="description"]'
    );
    if (metaDescriptionTag) {
      metaDescriptionTag.setAttribute(
        "content",
        "Web based Vehicle Inspection for Claims"
      );
    }
  } else {
    document.title = "Breakin Inspection";
    const metaDescriptionTag = document.querySelector(
      'meta[name="description"]'
    );
    if (metaDescriptionTag) {
      metaDescriptionTag.setAttribute(
        "content",
        "Web based Vehicle Inspection for Breakin"
      );
    }
  }

  const [locationBlocked, setLocationBlocked] = useState(true);

  // Use Redux state instead of local state for sunroof
  const isSunroof = useSelector((state) => state.isSunroof.isSunroof);

  let requestBody = {};
  if (breakinID) {
    requestBody = { breakin_id: breakinID };

  } else if (claimNumber) {
    source = new URLSearchParams(querySearch).get("Source");
    if (!source) source = "WAPC";

    requestBody = {
      claim_num: claimNumber,
      source_app: source,
      ...(userID ? { userID } : {}),
    };
    // console.log(requestBody);
    claimExists = true;
  }

  const [tnc, setTnC] = useState(useSelector((state) => state.tnc) || false);
  const [hasPreviousSession, setHasPreviousSession] = useState(false);
  const [areAllImagesClicked, setAreAllImagesClicked] = useState(false);
  const [breakinModalOpen, setBreakinModalOpen] = useState(false);
  const [claimModalOpen, setClaimModalOpen] = useState(false);
  const [disableRestore, setDisableRestore] = useState(false);

  // NEW: State for sunroof mode change confirmation
  const [sunroofChangeModalOpen, setSunroofChangeModalOpen] = useState(false);
  const [pendingSunroofValue, setPendingSunroofValue] = useState(null);

  const sessionId = useSelector((state) => state.car.sessionId);

  const [loading, setLoading] = useState(true);
  var car = useSelector((state) => state.car);
  const isClaim = useSelector((state) => state.isClaim);
  const isPAYD = useSelector((state) => state.isPAYD.isPAYD);

  const [captchaModalOpen, setCaptchaModalOpen] = useState(false);
  const [captchaReady, setCaptchaReady] = useState(false);
  const siteKey = import.meta.env.VITE_CAPTCHA_KEY;

  const no_cdf_sources = ["WAPC_MOBAPPS"];

  useEffect(() => {
    if (isRecaptchaEnabled() && window.grecaptcha?.enterprise) {
      window.grecaptcha.enterprise.ready(() => {
        setCaptchaReady(true);
        // console.log("reCAPTCHA Enterprise is ready");
      });
    } else {
      console.error("reCAPTCHA Enterprise not available");
    }
  }, []);

  useEffect(() => {
    dispatch(resetCarStateInitial());
    sessionStorage.clear();

    if (
      !breakin ||
      (breakin &&
        ((breakinID && breakin?.BRKIN_ID !== breakinID) ||
          (claimNumber && breakin?.claim_number !== claimNumber)))
    ) {
      if (claimExists) {
        dispatch(setIsClaim(claimExists));
        if (userID) {
          localStorage.setItem('user_id', userID);
        }
      }

      // Store ref_num & userID in local Storage
      const refNum = breakinID || claimNumber;
      if (refNum) {
        localStorage.setItem('ref_num', refNum);
      }



      // Get dynamic token and make API calls
      getDynamicToken()
        .then((dynamicToken) => {
          const requestOptions = {
            method: "POST",
            headers: {
              Authorization: `Bearer ${dynamicToken}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
          };

          // Step 1: Call /isInspectionAllowed
          fetch(
            `${import.meta.env.VITE_API_URL}/isInspectionAllowed`,
            requestOptions
          )
            .then((res) => res.json())
            .then((inspectionData) => {
              const isAllowed = Boolean(
                inspectionData.isAllowed === true ||
                inspectionData.isAllowed === "true"
              );

              if (!isAllowed) {
                dispatch(setBreakin(inspectionData));
                setLoading(false);
              } else {
                // Step 2: Proceed to call /breakin
                fetch(`${import.meta.env.VITE_API_URL}/breakin`, requestOptions)
                  .then((res) => res.json())
                  .then((data) => {
                    data.no_cdf_sources = no_cdf_sources;
                    if (localStorage && !localStorage.getItem("ls_source"))
                      localStorage.setItem("ls_source", data?.source_app);
                    dispatch(setBreakin(data));
                    dispatch(setSessionId(data.BRKIN_ID || data.claim_number));
                    if (!claimExists) {
                      dispatch(
                        setIsPAYD(
                          data.PAYD === "POLICY_RN" || data.PAYD === "POLICY"
                        )
                      );
                      if (odo_value) {
                        dispatch(setOdometerReading(odo_value));
                      }
                    }
                    setLoading(false);
                  })
                  .catch((err) => {
                    console.error("Error calling /breakin:", err);
                    setLoading(false);
                  });
              }
            })
            .catch((err) => {
              console.error("Error calling /isInspectionAllowed:", err);
              setLoading(false);
            });
        })
        .catch((err) => {
          console.error("Error fetching dynamic token:", err);
          setLoading(false);
        });
    }
  }, []);

  useEffect(() => {
    const handlePermissionChange = (event) => {
      const permissionStatus = event.target;

      if (permissionStatus.state === "granted") {
        setLocationBlocked(false);
      } else {
        setLocationBlocked(true);
        track('LOCATION_CAMERA_POPUP');
        navigator.geolocation.getCurrentPosition(
          () => setLocationBlocked(false),
          () => setLocationBlocked(true)
        );
      }
    };

    const setMaxResolution = async () => {
      try {
        // Get the list of available video input devices
        const devices = await navigator.mediaDevices.enumerateDevices();
        const videoDevices = devices.filter(
          (device) => device.kind === "videoinput"
        );

        // Try to find the back camera by label (contains 'back' or 'environment')
        const backCamera = videoDevices.find(
          (device) =>
            device.label.toLowerCase().includes("back") ||
            device.label.toLowerCase().includes("environment")
        );

        const constraints = {
          video: {
            deviceId: backCamera ? backCamera.deviceId : undefined,
            facingMode: backCamera ? undefined : "environment",
          },
        };

        const stream = await navigator.mediaDevices.getUserMedia(constraints);
        const track = stream.getVideoTracks()[0];
        const capabilities = track.getCapabilities();

        let maxWidth = 1024;
        let maxHeight = 768;

        if (capabilities.width?.max && capabilities.height?.max) {
          if (
            capabilities.width.max >= 1920 &&
            capabilities.height.max >= 1080
          ) {
            maxWidth = 1920;
            maxHeight = 1080;
          }
        }

        localStorage.setItem("maxWidth", maxWidth);
        localStorage.setItem("maxHeight", maxHeight);

        track.stop();
      } catch (error) {
        console.error("Error setting max resolution:", error);
      }
    };

    const initialize = () => {
      navigator.permissions.query({ name: "geolocation" }).then((result) => {
        result.onchange = handlePermissionChange;
        handlePermissionChange({ target: result }); // Initial check
      });

      setMaxResolution();
    };

    initialize();
  }, []);

  useEffect(() => {
    if (isClaim) {
      alterClaimCarData();
    } else if (isPAYD) {
      alterPayDCarData(breakin?.BRKIN_ID);
    } else if (!isClaim && !isPAYD && (breakin.BRKIN_ID || Object.keys(breakin).length !== 0)) {
      // Initialize breakin car data on load
      alterBreakinCarData();
    }
  }, [isClaim, isPAYD, breakin.BRKIN_ID]);

  // NEW: Update car data when sunroof selection changes (only for breakin, not claim or PAYD)
  useEffect(() => {
    if (!isClaim && !isPAYD && (breakin.BRKIN_ID || Object.keys(breakin).length !== 0)) {
      console.log('Sunroof state changed to:', isSunroof);
      alterBreakinCarData();
    }
  }, [isSunroof]);

  const alterClaimCarData = () => {
    if (import.meta.env.VITE_IS_PARTIAL_IMAGES_LIVE !== "1") {
      const filteredCars = InitialCarData.filter(
        (data) =>
          data.imgId !== "RC_Book_Back" && data.imgId !== "RC_Book_Front"
      );
      dispatch(setCars(filteredCars));
      dispatch(setCheckCount(12));
    } else {
      dispatch(setCars(InitialSplitCarData));
      dispatch(setCheckCount(14));
    }
  };

  const alterBreakinCarData = () => {
    // Select appropriate car data based on sunroof toggle from Redux
    const selectedCarData = isSunroof ? InitialSunroofCarData : InitialCarData;
    console.log('alterBreakinCarData called - isSunroof:', isSunroof);
    console.log('Selected car data length:', selectedCarData.length);
    console.log('Check count:', isSunroof ? 16 : 14);

    // Use setCars directly to ensure update happens
    dispatch(setCars(selectedCarData));
    dispatch(setCheckCount(isSunroof ? 16 : 14));
  };

  const alterPayDCarData = async (session) => {
    let filteredPAYDCars = InitialCarData.filter(
      (data) =>
        data.imgId === "Front" ||
        data.imgId === "Chassis_No" ||
        data.imgId === "ODO_Meter"
    ).map((data) => {
      if (data.imgId === "Chassis_No") {
        return { ...data, key: 2 };
      }
      if (data.imgId === "ODO_Meter") {
        return { ...data, key: 3 };
      }
      return { ...data };
    });

    if (session) {
      const existingCarData = await fetchCarData(session);
      if (existingCarData?.length > 0) filteredPAYDCars = existingCarData;
    }
    // Dispatch the modified list of cars for PAYD
    dispatch(setCars(filteredPAYDCars));
    dispatch(setCheckCount(2));
  };

  // NEW: Check previous session and set default sunroof state based on car count
  useEffect(() => {
    const checkPreviousSession = async () => {
      if (breakin.BRKIN_ID || breakin.claim_number) {
        try {
          const session = breakin.BRKIN_ID || breakin.claim_number;
          const existingCarData = await fetchCarData(session);

          if (existingCarData && existingCarData.length > 0) {
            // Count images incrementally until we hit a null/missing uploadImg
            let imageCount = 0;
            for (let i = 0; i < existingCarData.length; i++) {
              if (
                existingCarData[i].isUploadImg &&
                existingCarData[i].isUploadImg !== null
              ) {
                imageCount++;
              } else {
                // Stop counting when we encounter the first null/missing image
                break;
              }
            }

            // Show restore button if at least one image exists
            setHasPreviousSession(imageCount > 0);

            // Check if all images are present (for direct navigation to /upload)
            const allImagesClicked = imageCount === existingCarData.length;
            setAreAllImagesClicked(allImagesClicked);

            // NEW: Set default sunroof state based on existing car data length
            // 17 items = sunroof enabled, 15 items = no sunroof
            if (existingCarData.length === 17) {
              console.log('Previous session detected with 17 images - enabling sunroof mode');
              dispatch(setIsSunroof(true));
            } else {
              console.log(`Previous session detected with ${existingCarData.length} images - disabling sunroof mode`);
              dispatch(setIsSunroof(false));
            }
          } else {
            setHasPreviousSession(false);
            setAreAllImagesClicked(false);
            // No previous session - keep default (false)
            dispatch(setIsSunroof(false));
          }
        } catch (error) {
          console.error("Error checking previous session:", error);
          setHasPreviousSession(false);
          setAreAllImagesClicked(false);
        }
      }
    };

    checkPreviousSession();
  }, [breakin.BRKIN_ID, breakin.claim_number]);

  const isRecaptchaEnabled = async () => {
    return import.meta.env.VITE_ISCAPTCHA_ENABLED == "1";
  };

  const executeRecaptchaAndConfirm = async () => {
    //return 1;
    if (!isRecaptchaEnabled()) return 1;
    if (!captchaReady || !window.grecaptcha?.enterprise) {
      console.warn("reCAPTCHA not ready");
      return null;
    }

    try {
      const token = await window.grecaptcha.enterprise.execute(siteKey, {
        action: "start_inspection",
      });
      if (!token) {
        throw new Error("reCAPTCHA returned null token");
      }

      // console.log("reCAPTCHA token:", token);
      return token;
    } catch (error) {
      console.error("Error executing reCAPTCHA:", error);
      return null;
    }
  };

  const restorePreviousSession = async () => {
    try {
      if (!(await executeRecaptchaAndConfirm())) {
        setCaptchaModalOpen(true);
        return;
      }
      const session = breakin.BRKIN_ID || breakin.claim_number;
      const existingCarData = await fetchCarData(session);

      if (existingCarData) {
        // Dispatch the restored car data
        dispatch(setCars(existingCarData));

        // Count images incrementally for dispatching car count
        let imageCount = 0;
        for (let i = 0; i < existingCarData.length; i++) {
          if (existingCarData[i].isUploadImg) {
            imageCount++;
          } else {
            break;
          }
        }
        // car.uploadimg => car.uploadBlob to gen new

        // Dispatch the count (next image position)
        dispatch(carCount(imageCount + 1));

        // Navigate based on completion status
        if (areAllImagesClicked) {
          track('RESTORE_IMAGE_CLICKED');
          navigate("/upload");
        } else {
          track('RESTORE_IMAGE_CLICKED');
          navigate("/inspection");
        }
      }
    } catch (error) {
      console.error("Error restoring previous session:", error);
    }
  };

  // NEW: Handle sunroof toggle change with session check
  const handleSunroofChange = (newValue) => {
    if (hasPreviousSession && newValue !== isSunroof) {
      // Show confirmation modal if there's a previous session
      setPendingSunroofValue(newValue);
      setSunroofChangeModalOpen(true);
    } else {
      // No previous session, change directly
      dispatch(setIsSunroof(newValue));
    }
  };

  // NEW: Handle sunroof mode change confirmation - YES
  const handleSunroofChangeYes = async () => {
    try {
      console.log('Sunroof mode change confirmed - wiping session data');

      if (sessionId) {
        await deleteCarData(sessionId);
        console.log('Session data deleted successfully');
      }

      // Apply the new sunroof value
      dispatch(setIsSunroof(pendingSunroofValue));

      // Reset state
      dispatch(resetCarState());
      sessionStorage.clear();
      setHasPreviousSession(false);
      setAreAllImagesClicked(false);

      // Close modal
      setSunroofChangeModalOpen(false);
      setPendingSunroofValue(null);

      // Reload the page to ensure clean state
      console.log('Reloading app...');
      window.location.reload();
    } catch (error) {
      console.error('Error changing sunroof mode:', error);
      setSunroofChangeModalOpen(false);
      setPendingSunroofValue(null);
    }
  };

  // NEW: Handle sunroof mode change confirmation - NO
  const handleSunroofChangeNo = () => {
    console.log('Sunroof mode change cancelled');
    // Don't change the state, just close modal
    setSunroofChangeModalOpen(false);
    setPendingSunroofValue(null);
  };

  //! Modal Functions

  const handleStartBreakin = async () => {
    if (hasPreviousSession) {
      setBreakinModalOpen(true);
    } else {
      if (!(await executeRecaptchaAndConfirm())) {
        setCaptchaModalOpen(true);
        return;
      }
      navigate("/inspection");
    }
  };

  const handleStartClaim = async () => {
    if (hasPreviousSession) {
      setClaimModalOpen(true);
    } else {
      if (!(await executeRecaptchaAndConfirm())) {
        setCaptchaModalOpen(true);
        return;
      }
      // No previous session; proceed immediately
      if (
        breakin.is_ai_photos_uploaded &&
        !breakin.no_cdf_sources.includes(breakin.source_app)
      ) {
        navigate("/upload-cdf");
      } else {
        track('START_INSPECTION_CLICKED');
        navigate("/inspection");
      }
    }
  };

  const handleBreakinModalYes = async () => {
    if (!(await executeRecaptchaAndConfirm())) {
      setCaptchaModalOpen(true);
      return;
    }
    if (sessionId) {
      await deleteCarData(sessionId);
    }
    dispatch(resetCarState());
    sessionStorage.clear();

    setDisableRestore(true);

    if (isPAYD) {
      await alterPayDCarData();
    } else {
      // Set car data based on sunroof selection for breakin
      alterBreakinCarData();
    }
    dispatch(setSessionId(sessionId));
    navigate("/inspection");
  };

  const handleModalNo = () => {
    setBreakinModalOpen(false);
    setClaimModalOpen(false);
  };

  const handleCaptchaModalNo = () => {
    setCaptchaModalOpen(false);
  };

  const handleClaimModalYes = async () => {
    if (!(await executeRecaptchaAndConfirm())) {
      setCaptchaModalOpen(true);
      return;
    }
    if (sessionId) {
      deleteCarData(sessionId).catch((error) => {
        console.warn("Error deleting data from IndexedDB:", error);
      });
    }
    dispatch(resetCarState());
    sessionStorage.clear();

    setDisableRestore(true);

    alterClaimCarData();

    dispatch(setSessionId(sessionId));
    // window.location.reload();
    setClaimModalOpen(false);

    if (
      breakin.is_ai_photos_uploaded &&
      !breakin.no_cdf_sources.includes(breakin.source_app)
    ) {
      navigate("/upload-cdf");
    } else {
      track('RESTORE_IMAGE_CLICKED');
      navigate("/inspection");
    }
  };


  useEffect(() => {
    // Optional page-load event (HOME_LOADED is already tracked in TelemetryProvider)
    track('HOME_LOADED');
  }, [track]);

  if (
    breakin?.processFlag == 1 ||
    (no_cdf_sources.includes(breakin.source_app) &&
      breakin.is_ai_photos_uploaded)
  ) {
    if ((claimExists && breakin.is_ai_photos_uploaded) || isClaim) {
      return (
        <section className="success_container">
          <img src="/logo_hdfc.png" alt="hdfc-ergo" />
          {/* <p id="thankyou_txt">Claim already in process.</p> */}
          <p id="success_para">
            The claim number you have submitted is already in process.
          </p>
        </section>
      );
    } else {
      return (
        <section className="success_container">
          <img src="/logo_hdfc.png" alt="hdfc-ergo" />
          {/* <p id="thankyou_txt">Claim already in process.</p> */}
          <p id="success_para">
            The breakin ID you have submitted is already in process.
          </p>
        </section>
      );
    }
  } else if (
    breakin?.msg &&
    (breakin?.status == "INTERNAL_SERVER_ERROR" || breakin?.status == "LOCKED")
  ) {
    return (
      <section className="success_container">
        <img src="/logo_hdfc.png" alt="hdfc-ergo" />
        {/* <p id="thankyou_txt">Claim already in process.</p> */}
        <p id="success_para">{breakin.msg}</p>
      </section>
    );
  } else {
    if (claimExists) {
      return (
        <>
          <ImagePreloader />
          <CustomModal
            open={captchaModalOpen}
            message={"Please verify you're not a robot."}
            yesText="NA"
            noText="Close"
            onNo={handleCaptchaModalNo}
          />

          {locationBlocked && (
            <Modal>
              <div className="modalContainer">
                <div className="retake_modal">
                  <span>
                    Please allow location access from your browser and refresh.
                  </span>
                  <div className="yes_no_btn">
                    <button
                      style={{ backgroundColor: "#e42125" }}
                      onClick={() => window.location.reload()}
                    >
                      Refresh
                    </button>
                  </div>
                </div>
              </div>
            </Modal>
          )}
          {Object.keys(breakin).length !== 0 && breakin.claim_number ? (
            <>
              <div className="container">
                <div className="header_container">
                  <span>Claim Details:</span>
                  <p>
                    Please complete the inspection to process your claim
                    request.
                  </p>
                </div>
                <div className="box_container">
                  <div className="car_details">
                    <div className="inspection_id">
                      <p className="grey_shade">Claim Number</p>
                      <p className="dark_shade">
                        {breakin.claim_number || "N.A"}
                      </p>
                    </div>
                    <div className="vehicle_no">
                      <p className="grey_shade">Vehicle Reg. type</p>
                      <p className="dark_shade">
                        {breakin.registration || "N.A"}
                      </p>
                    </div>
                    <div className="inspection_date">
                      <p className="grey_shade">Accident Date</p>
                      <p className="dark_shade">{breakin.loss_date || "N.A"}</p>
                    </div>
                    <div className="make">
                      <p className="grey_shade">Make</p>
                      <p className="dark_shade">
                        {breakin.vehicle_make || "N.A"}
                      </p>
                    </div>
                    <div className="inspection_time">
                      <p className="grey_shade">Accident Time</p>
                      <p className="dark_shade">{breakin.loss_time || "N.A"}</p>
                    </div>
                    <div className="model">
                      <p className="grey_shade">Model</p>
                      <p className="dark_shade">
                        {breakin.vehicle_model || "N.A"}
                      </p>
                    </div>
                    <div className="name">
                      <p className="grey_shade">Insured Name</p>
                      <p className="dark_shade">
                        {breakin.insured_name || "N.A"}
                      </p>
                    </div>
                  </div>
                  {/* <div className="terms_checkbox">
                  <input
                    type="checkbox"
                    name="tnC"
                    checked={tnc}
                    value={tnc}
                    onChange={(e) => setTnC(e.target.checked)}
                  />
                  <label htmlFor="tnC" className="tnC">
                    I agree to HDFC ERGO{" "}
                    <span onClick={() => navigate("/terms&conditions")}>
                      Terms & Conditions
                    </span>
                  </label>
                </div> */}
                  <div className="inspection_btn">
                    <button
                      style={{ background: "#EC6466" }}
                      onClick={handleStartClaim}
                    >
                      START INSPECTION
                    </button>
                  </div>
                  {/* Claim Modal */}
                  <CustomModal
                    open={claimModalOpen}
                    message={
                      "We have detected images taken from previous session.\nAre you sure you want to start fresh inspection?"
                    }
                    yesText="Yes, Start Fresh"
                    noText="Cancel"
                    onYes={handleClaimModalYes}
                    onNo={handleModalNo}
                  />
                  {/* Restore session button - only visible when previous session exists */}
                  {hasPreviousSession && (
                    <div className="inspection_btn">
                      <button
                        disabled={disableRestore}
                        style={{ background: "#EC6466" }}
                        onClick={restorePreviousSession}
                      >
                        RESTORE IMAGES FROM PREVIOUS SESSION
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </>
          ) : (
            <>
              <Loader />
            </>
          )}
        </>
      );
    } else {
      return (
        <>
          <ImagePreloader />

          <CustomModal
            open={captchaModalOpen}
            message={"Please verify you're not a robot."}
            yesText="NA"
            noText="Close"
            onNo={handleCaptchaModalNo}
          />

          {/* NEW: Sunroof Mode Change Confirmation Modal */}
          <CustomModal
            open={sunroofChangeModalOpen}
            message={
              "Changing sunroof mode will delete all previously captured images.\nAre you sure you want to continue?"
            }
            yesText="Yes, Change Mode"
            noText="Cancel"
            onYes={handleSunroofChangeYes}
            onNo={handleSunroofChangeNo}
          />

          {Object.keys(breakin).length !== 0 ? (
            <>
              <div className="container">
                <div className="header_container">
                  <span>Inspection details</span>
                  <p>
                    please complete the inspection to process your policy
                    request
                  </p>
                </div>
                <div className="box_container">
                  <div className="car_details">
                    <div className="inspection_id">
                      <p className="grey_shade">Inspection ID</p>
                      <p className="dark_shade">{breakin.BRKIN_ID || "N.A"}</p>
                    </div>
                    <div className="vehicle_no">
                      <p className="grey_shade">Vehicle reg. no.</p>
                      <p className="dark_shade">
                        {breakin.REGISTRATION_NUMBER || "N.A"}
                      </p>
                    </div>
                    <div className="inspection_date">
                      <p className="grey_shade">Inspection Date</p>
                      <p className="dark_shade">
                        {breakin.INSPECTIONDATE || "N.A"}
                      </p>
                    </div>
                    <div className="make">
                      <p className="grey_shade">Make</p>
                      <p className="dark_shade">{breakin.MAKE || "N.A"}</p>
                    </div>
                    <div className="inspection_time">
                      <p className="grey_shade">Inspection Time</p>
                      <p className="dark_shade">N.A.</p>
                    </div>
                    <div className="model">
                      <p className="grey_shade">Model</p>
                      <p className="dark_shade">{breakin.MODEL || "N.A"}</p>
                    </div>
                  </div>

                  {!isClaim &&
                    !isPAYD &&
                    (breakin?.BRKIN_ID || Object.keys(breakin || {}).length !== 0) && (
                      <>
                        {/*//* Sunroof Toggle Section with confirmation logic */}
                        <SunroofToggle
                          hasSunroof={isSunroof}
                          setHasSunroof={handleSunroofChange}
                        />
                      </>
                    )}

                  <div className="terms_checkbox">
                    <input
                      type="checkbox"
                      name="tnC"
                      checked={tnc}
                      value={tnc}
                      onChange={(e) => setTnC(e.target.checked)}
                    />
                    <label htmlFor="tnC" className="tnC">
                      I agree to HDFC ERGO{" "}
                      <span onClick={() => navigate("/terms&conditions")}>
                        Terms & Conditions
                      </span>
                    </label>
                  </div>

                  <div className="inspection_btn">
                    <button
                      disabled={!tnc}
                      style={{ background: !tnc ? "#B0B0B0" : "#EC6466" }}
                      onClick={handleStartBreakin}
                    >
                      START INSPECTION
                    </button>
                  </div>
                  {/* Breakin Modal */}
                  <CustomModal
                    open={breakinModalOpen}
                    message={
                      "We have detected images taken from previous session.\nAre you sure you want to start fresh inspection?"
                    }
                    yesText="Yes, Start Fresh"
                    noText="Cancel"
                    onYes={handleBreakinModalYes}
                    onNo={handleModalNo}
                  />
                  {/* Restore session button - only visible when previous session exists */}
                  {hasPreviousSession && (
                    <div className="inspection_btn">
                      <button
                        disabled={!tnc || disableRestore}
                        style={{ background: !tnc ? "#B0B0B0" : "#EC6466" }}
                        onClick={restorePreviousSession}
                      >
                        RESTORE IMAGES FROM PREVIOUS SESSION
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </>
          ) : (
            <>
              <Loader />
            </>
          )}
        </>
      );
    }
  }
};

export default Home;